import { route } from 'mithril'
import BaseView from './BaseView'
import { nodes, bem } from '../../utils/dom'
import { mount, unmount } from '../../utils/component'
import { createElementWithCallback, routeAndDispatch } from '../../utils/mithril'
import { MOUNT_POINTS, SELECTORS } from '../../config/preRenderedSelectorsConfig'

const CLASS_CONSTANTS = {
  NUM_SLIDES_TO_PRELOAD: 3,
  NEXT_ANIMATION_CLASS: 'next-animation',
  PREV_ANIMATION_CLASS: 'prev-animation',
  MEDIA_SELECTORS: ['img', 'iframe'],
}

let slideshowButtonsBem = bem(SELECTORS.SLIDE.substring(1))
let slideshowBem = bem(MOUNT_POINTS.SLIDE_CONTAINER.substring(1))

export default class SlideshowView extends BaseView {
  constructor() {
    super()
    this.slides = MOUNT_POINTS.SLIDE_CONTAINER
  }

  view(ctrl) {
    // Can be used without specific element. In such case creates dummy element not rendered in the Dom
    return createElementWithCallback({
      callback: this.viewRenderCallback(ctrl),
    })
  }

  viewRenderCallback(ctrl) {
    let { vm } = ctrl
    return (element, isInit, context) => {
      this.conditionallyChangeSlide(vm)
      this.instantiateButtons(vm)
    }
  }

  set slides(selector) {
    this._slides = Array.from(nodes(selector))
  }

  get slides() {
    return this._slides
  }

  getButtonSelectors(modifiers) {
    return `${slideshowButtonsBem('button', modifiers)}`
  }

  get buttonNodes() {
    return Array.from(
      nodes(
        this.getButtonSelectors({
          prev: true,
          next: true,
          first: true,
          start: true,
        })
          .split(' ')
          .join(',.')
      )
    )
  }

  navigateToRouteByNodeData(buttonNode, vm) {
    let url = buttonNode.dataset.title ? `/${buttonNode.dataset.title}` : ''
    let routes = route().includes('?')
      ? route().substring(0, route().indexOf('?')).split('/')
      : route().split('/')
    if (route.param('slideId')) {
      routes.pop()
    }
    routes = routes.join('/')
    url = `${routes}${url}${window.location.search}`
    vm.scrollPosition =
      window.scrollY === undefined ? document.body.parentNode.scrollTop : window.scrollY
    routeAndDispatch(url)
  }

  instantiateButtons(vm) {
    let { buttonNodes, navigateToRouteByNodeData } = this
    if (!vm.store.initializationFinished) {
      buttonNodes.forEach(function addClickHandler(buttonNode) {
        buttonNode.onclick = function buttonOnClickRouteChange(e) {
          e.preventDefault()
          navigateToRouteByNodeData(buttonNode, vm)
        }
      })
      vm.slideshowInitializationFinished()
    }
  }

  conditionallyChangeSlide(vm) {
    let { currentSlideIndex, initializationFinished } = vm.store
    let { newSlideIndex } = vm
    if (currentSlideIndex !== newSlideIndex || !initializationFinished) {
      this.scrollToPreviousScrollPosition(vm)
      let { PREV_ANIMATION_CLASS, NEXT_ANIMATION_CLASS } = CLASS_CONSTANTS
      let direction =
        currentSlideIndex - newSlideIndex > 0 ? PREV_ANIMATION_CLASS : NEXT_ANIMATION_CLASS
      this.changeSlide(vm, newSlideIndex, direction)
    }
  }

  changeSlide(vm, slideId, direction) {
    let { slides } = this
    let { currentSlideIndex } = vm.store
    let { PREV_ANIMATION_CLASS, NEXT_ANIMATION_CLASS } = CLASS_CONSTANTS
    slides[currentSlideIndex].className = slideshowBem({
      visible: false,
      [PREV_ANIMATION_CLASS]: false,
      [NEXT_ANIMATION_CLASS]: false,
    })
    slides[slideId].className = slideshowBem({
      visible: true,
      [direction]: true,
    })
    this.stopSlideVideo(currentSlideIndex)
    this.preloadNextImages(currentSlideIndex)
    vm.completeSlideChange(slideId)
    return this
  }

  scrollToPreviousScrollPosition(vm) {
    window.scroll(0, vm.scrollPosition)
  }

  stopSlideVideo(slideId) {
    const slide = this.slides[slideId]
    Array.from(slide.getElementsByTagName('iframe'))
      // causes the iframe to reload, so if the video is playing, it will stop
      .map(iframeEl => (iframeEl.src = iframeEl.src))
  }

  preloadNextImages(currentIndex, preloadCount = CLASS_CONSTANTS.NUM_SLIDES_TO_PRELOAD) {
    let { slides } = this
    let preloadUpToIndex = Math.min(slides.length, currentIndex + preloadCount)
    Array.from(slides).slice(currentIndex, preloadUpToIndex).forEach(this.loadMedia)
    return this
  }

  loadMedia(el) {
    if (!el) {
      return
    }
    CLASS_CONSTANTS.MEDIA_SELECTORS.forEach(function loadMedia(typeSelector) {
      for (let media of el.querySelectorAll(`${typeSelector}[data-src]`)) {
        media.setAttribute('src', media.getAttribute('data-src'))
        media.removeAttribute('data-src')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/SlideshowView.js